// import React, { useState, useEffect, useRef } from "react";
// import css from "./card.module.css";
// import { HandySvg } from "handy-svg";
// import iconSrc from "../../../svg/xCardIcon.svg";
// import ProdInCard from "./prodInCard";
// import { Link, useNavigate } from "react-router-dom";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../../../firebase";

// export default function Card({
//   setCart,
//   setCountProductForCart,
//   setCartCounterC,
// }) {
//   const [products, setProducts] = useState([]);
//   const [haveProduct, setHaveProduct] = useState(false);
//   const [cartProducts, setCartProducts] = useState([]);
//   const [finishPrice, setFinishPrice] = useState(0);
//   const navigate = useNavigate();
//   const popUpRef = useRef(null);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       const productsRef = collection(db, "product");
//       const productsSnapshot = await getDocs(productsRef);
//       const productsList = productsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const actionsSnapshot = await getDocs(collection(db, "actions"));
//       const actions = actionsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const cartItems = JSON.parse(localStorage.getItem("cart")) || [];

//       const now = new Date();

//       const productsWithQuantities = cartItems.map((item) => {
//         const foundProduct = productsList.find((p) => p.id === item.uid);

//         const matchedAction = actions.find((action) => {
//           const start = action.startDate ? new Date(action.startDate) : null;
//           const end = new Date(action.endDate);

//           const matchProduct = action.appliesTo.products?.includes(
//             foundProduct.id
//           );

//           const productSeries = Array.isArray(foundProduct.seria)
//             ? foundProduct.seria
//             : typeof foundProduct.seria === "string" &&
//               foundProduct.seria !== ""
//             ? [foundProduct.seria]
//             : [];

//           const matchSeries = productSeries.some((ser) =>
//             action.appliesTo.series?.includes(ser)
//           );

//           const productAuthors = Array.isArray(foundProduct.textAutor)
//             ? foundProduct.textAutor.map((a) => a.split(" ")[0].trim())
//             : typeof foundProduct.textAutor === "string" &&
//               foundProduct.textAutor !== ""
//             ? [foundProduct.textAutor.split(" ")[0].trim()]
//             : [];

//           const actionAuthors = Array.isArray(action.appliesTo.authors)
//             ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
//             : [];

//           const matchAuthor = productAuthors.some((a) =>
//             actionAuthors.includes(a)
//           );

//           return (
//             (matchProduct || matchSeries || matchAuthor) &&
//             (!start || now >= start) &&
//             now <= end
//           );
//         });

//         let finalPrice = foundProduct.price;
//         let isActionPrice = false;

//         if (matchedAction && matchedAction.discountPercent) {
//           finalPrice = Math.round(
//             foundProduct.price -
//               (foundProduct.price * matchedAction.discountPercent) / 100
//           );
//           isActionPrice = true;
//         }

//         return {
//           ...foundProduct,
//           quantity: item.quantity,
//           finalPrice,
//           isActionPrice,
//         };
//       });

//       setProducts(productsList);
//       setCartProducts(productsWithQuantities);
//       setHaveProduct(true);
//     };

//     fetchProducts();
//   }, []);

//   const cartClose = () => {
//     setCart(false);
//   };

//   const popUpRefHandler = (e) => {
//     if (popUpRef.current && !popUpRef.current.contains(e.target)) {
//       cartClose();
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", popUpRefHandler);
//     return () => {
//       document.removeEventListener("mousedown", popUpRefHandler);
//     };
//   }, []);

//   const handleQuantityChange = (uid, quantity) => {
//     const updatedCartProducts = cartProducts.map((product) =>
//       product.uid === uid ? { ...product, quantity } : product
//     );

//     const productToUpdate = updatedCartProducts.find(
//       (product) => product.uid === uid
//     );

//     if (productToUpdate) {
//       const cart = JSON.parse(localStorage.getItem("cart"));
//       const updatedCart = cart.map((product) =>
//         product.uid === uid ? { ...product, quantity } : product
//       );
//       localStorage.setItem("cart", JSON.stringify(updatedCart));
//     }

//     const totalQuantity = updatedCartProducts.reduce(
//       (acc, product) => acc + product.quantity,
//       0
//     );

//     const totalPrice = updatedCartProducts.reduce(
//       (acc, product) => acc + product.finalPrice * product.quantity,
//       0
//     );

//     setCartCounterC((prev) => prev + 1);
//     setCartProducts(updatedCartProducts);
//     setFinishPrice(totalPrice);
//     setCountProductForCart(totalQuantity);
//   };

//   const removeProduct = (uid) => {
//     const updatedCart = cartProducts.filter((product) => product.uid !== uid);
//     localStorage.setItem("cart", JSON.stringify(updatedCart));
//     setCartProducts(updatedCart);

//     const totalQuantity = updatedCart.reduce(
//       (acc, product) => acc + product.quantity,
//       0
//     );
//     const totalPrice = updatedCart.reduce(
//       (acc, product) => acc + product.finalPrice * product.quantity,
//       0
//     );

//     setCartCounterC((prev) => prev + 1);
//     setFinishPrice(totalPrice);
//     setCountProductForCart(totalQuantity);
//   };

//   useEffect(() => {
//     const totalPrice = cartProducts.reduce(
//       (acc, product) => acc + product.finalPrice * product.quantity,
//       0
//     );
//     const totalQuantity = cartProducts.reduce(
//       (acc, product) => acc + product.quantity,
//       0
//     );
//     setFinishPrice(totalPrice);
//     setCountProductForCart(totalQuantity);
//   }, [cartProducts]);

//   const goToOrder = () => {
//     if (cartProducts.length > 0) {
//       setCart(false);
//       navigate("/order");
//     }
//   };

//   return (
//     <div className={css.cardWrap}>
//       {cartProducts && (
//         <div className={css.popUpWrap} ref={popUpRef}>
//           <div className={css.nameCountWrap}>
//             <h2 className={css.countH2}>Ваш кошик ({cartProducts.length})</h2>
//             <HandySvg
//               onClick={cartClose}
//               src={iconSrc}
//               width="28"
//               className={css.countSvg}
//               height="28"
//             />
//           </div>

//           <div className={css.productInCardWrap}>
//             {cartProducts.map((el, index) => (
//               <ProdInCard
//                 key={index}
//                 el={el}
//                 removeProduct={removeProduct}
//                 handleQuantityChange={handleQuantityChange}
//               />
//             ))}
//           </div>

//           <div className={css.fullPriceBlockWrap}>
//             <h3 className={css.finalPrice}>Всього: {finishPrice} грн</h3>
//             <div className={css.buttonPriceWrap}>
//               <div className={css.nextJoin} onClick={cartClose}>
//                 Продовжити вибір
//               </div>
//               <div onClick={goToOrder} className={css.finalOrder}>
//                 Оформити замовлення
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
import React, { useState, useEffect, useRef } from "react";
import css from "./card.module.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/xCardIcon.svg";
import ProdInCard from "./prodInCard";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import { useNavigate } from "react-router-dom";

export default function Card({
  setCart,
  setCountProductForCart,
  setCartCounterC,
}) {
  const [cartProducts, setCartProducts] = useState([]);
  const [finishPrice, setFinishPrice] = useState(0);
  const navigate = useNavigate();
  const popUpRef = useRef(null);

  useEffect(() => {
    const fetchProducts = async () => {
      const productsSnapshot = await getDocs(collection(db, "product"));
      const allProducts = productsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const bundlesSnapshot = await getDocs(collection(db, "bundles"));
      const bundles = bundlesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const actionsSnapshot = await getDocs(collection(db, "actions"));
      const actions = actionsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const cartItems = JSON.parse(localStorage.getItem("cart")) || [];

      const now = new Date();

      // Крок 1: сформуй повний список товарів у кошику
      let productsInCart = cartItems.map((item) => {
        const found = allProducts.find((p) => p.id === item.uid);
        return { ...found, quantity: item.quantity, uid: found.id };
      });

      // Крок 2: знайди товари, які належать до однієї зв’язки (бандлу)
      bundles.forEach((bundle) => {
        const bundleProductIds = bundle.products.map((p) => p.productId);

        const matchingProducts = productsInCart.filter((p) =>
          bundleProductIds.includes(p.id)
        );

        // if (matchingProducts.length >= 2) {
        //   // Якщо є мінімум 2 товари зв’язки у кошику — знайди другий і постав йому знижку
        //   let found = 0;
        //   for (let i = 0; i < productsInCart.length; i++) {
        //     const product = productsInCart[i];
        //     if (bundleProductIds.includes(product.id)) {
        //       found += 1;
        //       if (found === 2) {
        //         // Застосуй знижку тільки до другого знайденого
        //         const bundleDiscount = bundle.products.find(
        //           (p) => p.productId === product.id
        //         )?.discount;

        //         product.bundleDiscount = bundleDiscount || 0;
        //         break; // лише до 1 продукту!
        //       }
        //     }
        //   }
        // }
        if (matchingProducts.length >= bundle.products.length) {
          productsInCart = productsInCart.map((product) => {
            const bundleProduct = bundle.products.find(
              (p) => p.productId === product.id
            );

            if (bundleProduct) {
              return {
                ...product,
                bundleDiscount: bundleProduct.discount,
              };
            }

            return product;
          });
        }
      });

      // Крок 3: застосуй акційні знижки
      const updated = productsInCart.map((p) => {
        let finalPrice = p.price;

        const matchedAction = actions.find((action) => {
          const start = action.startDate ? new Date(action.startDate) : null;
          const end = new Date(action.endDate);

          const matchProduct = action.appliesTo.products?.includes(p.id);

          const productSeries = Array.isArray(p.seria)
            ? p.seria
            : typeof p.seria === "string" && p.seria !== ""
            ? [p.seria]
            : [];

          const matchSeries = productSeries.some((ser) =>
            action.appliesTo.series?.includes(ser)
          );

          const productAuthors = Array.isArray(p.textAutor)
            ? p.textAutor.map((a) => a.split(" ")[0].trim())
            : typeof p.textAutor === "string" && p.textAutor !== ""
            ? [p.textAutor.split(" ")[0].trim()]
            : [];

          const actionAuthors = Array.isArray(action.appliesTo.authors)
            ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
            : [];

          const matchAuthor = productAuthors.some((a) =>
            actionAuthors.includes(a)
          );

          return (
            (matchProduct || matchSeries || matchAuthor) &&
            (!start || now >= start) &&
            now <= end
          );
        });

        if (matchedAction?.discountPercent) {
          finalPrice = Math.round(
            finalPrice - (finalPrice * matchedAction.discountPercent) / 100
          );
          p.isActionPrice = true;
        }

        if (p.bundleDiscount) {
          finalPrice = Math.round(
            finalPrice - (finalPrice * p.bundleDiscount) / 100
          );
          p.isBundlePrice = true;
        }

        p.finalPrice = finalPrice;
        return p;
      });

      setCartProducts(updated);
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const total = cartProducts.reduce(
      (acc, p) => acc + p.finalPrice * p.quantity,
      0
    );
    const totalQty = cartProducts.reduce((acc, p) => acc + p.quantity, 0);
    setFinishPrice(total);
    setCountProductForCart(totalQty);
  }, [cartProducts]);

  const cartClose = () => setCart(false);

  const handleQuantityChange = (uid, qty) => {
    const updated = cartProducts.map((p) =>
      p.uid === uid ? { ...p, quantity: qty } : p
    );

    const cartLS = JSON.parse(localStorage.getItem("cart")).map((p) =>
      p.uid === uid ? { ...p, quantity: qty } : p
    );
    localStorage.setItem("cart", JSON.stringify(cartLS));
    setCartProducts(updated);
    setCartCounterC((prev) => prev + 1);
  };

  const removeProduct = (uid) => {
    const updated = cartProducts.filter((p) => p.uid !== uid);
    const cartLS = JSON.parse(localStorage.getItem("cart")).filter(
      (p) => p.uid !== uid
    );
    localStorage.setItem("cart", JSON.stringify(cartLS));
    setCartProducts(updated);
    setCartCounterC((prev) => prev + 1);
  };

  const popUpRefHandler = (e) => {
    if (popUpRef.current && !popUpRef.current.contains(e.target)) {
      cartClose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", popUpRefHandler);
    return () => document.removeEventListener("mousedown", popUpRefHandler);
  }, []);

  const goToOrder = () => {
    if (cartProducts.length > 0) {
      setCart(false);
      navigate("/order");
    }
  };

  return (
    <div className={css.cardWrap}>
      <div className={css.popUpWrap} ref={popUpRef}>
        <div className={css.nameCountWrap}>
          <h2 className={css.countH2}>Ваш кошик ({cartProducts.length})</h2>
          <HandySvg
            onClick={cartClose}
            src={iconSrc}
            width="28"
            height="28"
            className={css.countSvg}
          />
        </div>

        <div className={css.productInCardWrap}>
          {cartProducts.map((el, index) => (
            <ProdInCard
              key={index}
              el={el}
              handleQuantityChange={handleQuantityChange}
              removeProduct={removeProduct}
            />
          ))}
        </div>

        <div className={css.fullPriceBlockWrap}>
          <h3 className={css.finalPrice}>Всього: {finishPrice} грн</h3>
          <div className={css.buttonPriceWrap}>
            <div className={css.nextJoin} onClick={cartClose}>
              Продовжити вибір
            </div>
            <div className={css.finalOrder} onClick={goToOrder}>
              Оформити замовлення
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
